<template>
  <van-popup
    v-model="isShow"
    style="height: 100%; width: 100%; background-color: transparent"
    :style="themeVarObj"
    :overlay="false"
    position="right"
  >
    <div
      class="role-wrapper"
      :class="type"
      :style="{
        paddingTop: stateHeight,
      }"
    >
      <div class="header-content">
        <span v-if="$store.getters.appType !=='weixin'" class="icon-back" @click="handleClose"></span>
        <van-icon v-else name="cross" class="icon-close" size="24" @click="handleClose" />
        <span>{{ title }}</span>
      </div>
      <DictList
        :list="list"
        :id="id"
        :active="active"
        :isSubmit="isSubmit"
        :type="type"
        :max="1"
        :min="min"
        :theme="theme"
        :selectValue="selectValue"
        :selectdItems.sync="selectdItems"
        :componentConfig="componentConfig"
        :newHotCityInfo="newHotCityInfo"
        @handleSubmit="handleSubmit"
        @saveBtn="saveBtn"
      />
    </div>
  </van-popup>
</template>

<script>
import { Popup } from "vant";
import { mapState } from "vuex";
import { getCityDictData } from "@51job/jbs-components-apis";

// import DD_INDTYPE from "./jobarea.js";
import DictList from "./dictList";
export default {
  name: "JbsExpectedCityPopup",
  props: {
    type: String,
    visible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      required: false,
    },
    max: {
      type: Number,
      required: false,
      default: 1,
    },
    min: {
      type: Number,
      default: 1,
    },
    theme: {
      type: String,
      required: false,
      default: () => "orange", //orange-社招 yellow-校招
    },
    // appa内嵌 上边距
    appStateHeight: {
      type: [Number, String],
      required: false,
      default: () => 0,
    },
    // type: {
    //   type: String,
    //   required: false,
    //   default: () => "51job"
    // }
    componentConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectValue: [], // 回显的默认选中值
      list: [],
      active: 0,
      isShow: false,
      isSubmit: false,
      selectdItems: [], // 当前选中值
      newHotCityInfo: {
        type: 1,
        title: "热门城市",
        eItems: [],
        items: [],
      },
      defualtCityName: "全国",
      stateHeight: 0,
    };
  },
  computed: {
    ...mapState(["commonStore"]),
    themeVarObj() {
      if (this.theme === "orange") {
        return {
          "--activeColor": "#FF6C0E",
          "--activeLineColor": "#FF6F26",
          "--selecteBg": "#FFF4E7",
          "--selectBorder": "#FF9F55",
          "--btnBg": "#FF6C0E",
          "--btnColor": "#FFF",
          "--appStateHeight":
            typeof this.appStateHeight === "number"
              ? `${this.appStateHeight}px`
              : this.appStateHeight,
        };
      } else {
        return {
          "--activeColor": "#e38400",
          "--activeLineColor": "#FFD54D",
          "--selecteBg": "#fff9e4",
          "--selectBorder": "#ffe48c",
          "--btnBg": "#FFD74D",
          "--btnColor": "#222",
          "--appStateHeight":
            typeof this.appStateHeight === "number"
              ? `${this.appStateHeight}px`
              : this.appStateHeight,
        };
      }
    },
  },

  async created() {
    if(this.$store.state.commonStore.searchPage){
      this.stateHeight = '0px'
    }else{
      this.stateHeight = await this.$base.getAppStateHeight();
    }
    this.initList();
  },
  methods: {
    // 保存按钮
    saveBtn() {
      // 是否保存
      this.isSubmit = true;
      this.handleClose();
    },
    async initList() {
      const res = await getCityDictData();
      // 过滤
      this.list = res.items.filter(
        (item) =>
          item.title !== "全国" &&
          item.title !== "国外" &&
          item.title !== "一线/新一线" &&
          item.title !== "二线城市"
      );
      // 存在activeCityList，过滤城市全量数据展示在热门，并匹配defaultCity对应城市
      if (this.componentConfig.activeCityList.length > 0) {
        this.filterCityList(this.list, this.componentConfig.activeCityList);
      }
      this.handleCityEcho();
    },
    // 城市回显
    handleCityEcho() {
      if (this.componentConfig.activeCityList.length > 0) {
        //回显城市
        this.newHotCityInfo?.items?.forEach((items) => {
          const cityCode = this.commonStore.currentAreaCode;
          if (items.code == cityCode) {
            this.$parent.changeCity(items.value);
            return;
          }
        });
      } else {
        this.list.forEach((item) => {
          item.items.forEach((sItem) => {
            const currentAreaCode = this.commonStore.currentAreaCode;
            const cityCode = currentAreaCode.indexOf(',') ? currentAreaCode.split(',')[0] : currentAreaCode;
            if (sItem.code == cityCode) {
              this.$parent.changeCity(sItem.value);
              return;
            }
          });
        });
      }
      // 单独处理全国
      if (this.commonStore.currentAreaCode == "000000") {
        this.$parent.changeCity("全国");
      }
    },

    // 筛选城市列表
    filterCityList(allCityList, activeCityList) {
      let eItems = [];
      let items = [];
      allCityList.forEach((item) => {
        if (item.title !== "热门城市") {
          item.eItems.forEach((sEItem) => {
            if (activeCityList.includes(sEItem.code)) {
              eItems.push(sEItem);
              return;
            }
          });
          item.items.forEach((sItem) => {
            if (activeCityList.includes(sItem.code)) {
              items.push(sItem);
              return;
            }
          });
        }
      });
      this.newHotCityInfo.eItems = eItems;
      this.newHotCityInfo.items = items;
    },
    // 处理回显数据
    recursionSearch(list) {
      const selects = [];
      const ids = this.id.split(",");
      list.forEach((item) => {
        if (item.items) {
          selects.push(...this.recursionSearch(item.items));
        } else if (ids.includes(item.code)) {
          selects.push({
            code: item.code,
            value: item.value,
          });
        }
      });
      return Array.from(new Set(selects.map(JSON.stringify))).map(JSON.parse);
    },
    // 保存后回传数据方法
    handleSubmit(val) {
      this.isSubmit = false;
      this.$emit("handleSubmit", val);
    },
    handleDelete(index) {
      this.selectValue.splice(index, 1);
      this.handleChange();
    },

    handleClose() {
      this.isShow = false;
      this.$emit("update:visible", false);
      this.$emit("onClose");
    },
    handleReset() {
      this.active = 0;
      this.selectValue = [];
      this.handleChange();
    },
    handleChange() {
      let codes = [];
      let values = [];
      let alias = [];
      this.selectValue.forEach((item) => {
        codes.push(item.code);
        values.push(item.value);
        alias.push(item.alias);
      });
      this.$emit("onChange", {
        alias: alias.join(","),
        code: codes.join(","),
        selects: this.selectValue,
        value: values.join(","),
      });
    },
  },
  components: {
    [Popup.name]: Popup,
    DictList,
  },
  watch: {
    visible(status) {
      this.isShow = status;
      const selectedCodes = this.selectdItems.map((el) => el.code);
      if (status && this.id?.trim() && this.id != selectedCodes.toString()) {
        // 回显数据  传入的默认选中值字符串和当前选中的不一致时再去重新获取默认数据
        this.selectValue = this.recursionSearch(this.list);
      }
    },
  },
};
</script>
<style scoped lang="less">
@import "./index.css";
.submitBtn {
  position: absolute;
  right: 16px;
  font-size: 16px;
}
.role-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100% - var(--appStateHeight));
  background-color: #fff;
  padding-top: var(--appStateHeight);
}
.role-wrapper .search-content {
  margin: 8px 16px;
  height: 36px;
  background: #f5f6f7;
  border-radius: 18px;
  display: flex;
}
.role-wrapper .search-content .icon-search {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url("@/assets/img/activity/icon-search.png") no-repeat;
  background-size: 16px 16px;
  margin: 10px 16px;
}
.role-wrapper .search-content .search-input {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 400;
  color: #222;
}
.role-wrapper .search-content .search-input::-webkit-input-placeholder {
  color: #afb3ba;
  font-size: 14px;
  font-weight: 400;
}
.role-wrapper .operation-content {
  height: 64px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-top: 1px solid #edeff2;
}
.role-wrapper .operation-content .btn-reset {
  width: 100px;
  height: 44px;
  text-align: center;
  line-height: 44px;
  background: #f5f6f7;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  color: #4c4f54;
}

.role-wrapper .operation-content .btn-reset.disabled {
  opacity: 0.5;
}
.role-wrapper .operation-content .btn-save {
  width: 232px;
  height: 44px;
  text-align: center;
  line-height: 44px;
  background: var(--btnBg);
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  color: var(--btnColor);
}
</style>
